"use client";

import { c as _c } from "react/compiler-runtime";
import Link from "next/link";

/**
 * A wrapper around the Next.js Link component for internal and external links.
 */
export default function AppAnchor(props) {
  const $ = _c(4);
  if (props.href.startsWith("/")) {
    let t0;
    if ($[0] !== props) {
      t0 = <Link href={props.href} passHref={true} {...props} />;
      $[0] = props;
      $[1] = t0;
    } else {
      t0 = $[1];
    }
    return t0;
  }
  let t0;
  if ($[2] !== props) {
    t0 = <a href={props.href} {...props} />;
    $[2] = props;
    $[3] = t0;
  } else {
    t0 = $[3];
  }
  return t0;
}